import React, { useEffect, useMemo } from "react";
import { useForm } from "react-hook-form";
import { Button } from "primereact/button";
import EzControlledDropDowntWithFloatingLabel from "../../../../common/EzForm/EzControlledDropDown/WithFloatingLabel";
import "./styles.css";
import Breadcrumb from "../../../../common/Breadcrumb";
import { useStyles } from "../style";
import {
  CompaniesBreadcrumb,
  basicDetail,
  editMode,
  createOnlyFields,
  statusDD,
  planTypeDD,
} from "./constant";
import { Container, Grid } from "@mui/material";
import EzControlledInputWithFloatingLabel from "../../../../common/EzForm/EzControlledInput/WithFloatingLabel";
import { EzToast, TOAST_SEVERITY } from "../../../../common/EzToast";
import { useNavigate } from "react-router-dom";
import { APP_URLS } from "../../../../utils/constant";

const CreateCompaniesComponent = (props) => {
  const navigate = useNavigate();
  const {
    initCreateCompaniesScreen,
    createCompanies,
    editCompanies,
    isLoading,
    isCompaniesCreateSuccess,
    isCompaniesCreateError,
    isCompaniesDetailSuccess,
    isCompaniesDetailError,
    isCompaniesEditSuccess,
    isEdit,
    formFieldValueMap,
    shouldBlockNavigation,
  } = props;

  const classes = useStyles();

  const {
    control,
    formState: { errors, isDirty },
    handleSubmit,
    reset,
  } = useForm({
    defaultValues: useMemo(() => {
      return formFieldValueMap;
    }, [formFieldValueMap]),
  });

  const navigateToCompaniesScreen = () => {
    navigate(APP_URLS.SYSTEM_COMPANIES.HOME);
  };

  useEffect(() => {
    if (!isCompaniesCreateSuccess && !isCompaniesEditSuccess) {
      shouldBlockNavigation(isDirty);
    }
  }, [isDirty, shouldBlockNavigation, isCompaniesCreateSuccess, isCompaniesEditSuccess]);

  useEffect(() => {
    if (isCompaniesCreateSuccess || isCompaniesEditSuccess) {
      reset();
    }
  }, [isCompaniesCreateSuccess, isCompaniesEditSuccess, reset]);

  useEffect(() => {
    if (isCompaniesDetailSuccess) {
      reset({
        ...formFieldValueMap,
      });
    }
  }, [isCompaniesDetailSuccess, formFieldValueMap, reset]);

  useEffect(() => {
    initCreateCompaniesScreen();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onSubmit = (data) => {
    const submitData = { ...data };

    if (!isEdit) {
      submitData.notify_email = localStorage.getItem("username");
    }

    isEdit
      ? editCompanies({ id: data.id, data: submitData })
      : createCompanies(submitData);
  };

  const getToastProps = () => {
    const toastTitle = "Please fill all required fields";
    return {
      severity: TOAST_SEVERITY.ERROR,
      toastTitle,
      shouldShowToast: false,
    };
  };

  const getFormErrorMessage = (name) => {
    return (
      errors[name] && <small className="p-error">{errors[name].message}</small>
    );
  };

  const getDropdownOptions = (fieldName) => {
    switch (fieldName) {
      case "status":
        return statusDD;
      case "planType":
        return planTypeDD;
      default:
        return [];
    }
  };

  const renderFormField = (item) => {
    if (item.type === "dropdown") {
      return (
        <Grid item xs={12} sm={6} md={4} lg={3} key={item.name}>
          <EzControlledDropDowntWithFloatingLabel
            name={item?.name}
            control={control}
            rules={item?.rule}
            optionLabel={"name"}
            optionValue={"id"}
            options={getDropdownOptions(item.name)}
            isError={errors[item?.name]}
            errorMsg={getFormErrorMessage(item?.name)}
            label={item?.label}
            labelClassName={"ml-2"}
          />
        </Grid>
      );
    }

    return (
      <Grid item xs={12} sm={6} md={4} lg={3} key={item.name}>
        <EzControlledInputWithFloatingLabel
          name={item?.name}
          control={control}
          label={item?.label}
          type={item?.type}
          rules={item?.rule}
          isError={errors[item?.name]}
          errorMsg={getFormErrorMessage(item?.name)}
        />
      </Grid>
    );
  };

  const renderPageHeaderSection = () => {
    return (
      <div className="make-relative sub-header ">
        <div className="maintitlediv">
          <div className="ml-3">
            <h4 className="pagetitle">
              {isEdit ? "Update Company" : "Create Company"}
            </h4>
          </div>
          <div className="buttonarea">
            <Button
              tooltip={"Back to Companies"}
              tooltipOptions={{ position: "left" }}
              label={"Back to Companies"}
              className={`p-button `}
              style={{ borderRadius: "10px" }}
              onClick={navigateToCompaniesScreen}
            />
          </div>
        </div>
      </div>
    );
  };

  return (
    <Container maxWidth="lg">
      <Breadcrumb list={CompaniesBreadcrumb} />
      <EzToast {...getToastProps()} />
      <div className={`containerbox ${classes.bg}`}>
        {renderPageHeaderSection()}
        <div className="form-demo">
          <form onSubmit={handleSubmit(onSubmit)} className="p-fluid">

            <h5 className="section-title mt-3 mb-2">Company Details</h5>
            <Grid container spacing={2}>
              {basicDetail?.map((item) => renderFormField(item))}
            </Grid>

            {!isEdit && (
              <>
                <h5 className="section-title mt-3 mb-2">Admin User Detail</h5>
                <Grid container spacing={2}>
                  {createOnlyFields?.map((item) => renderFormField(item))}
                </Grid>
              </>
            )}
            <div className={"make-flex mt-3 mr-2"}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "end",
                }}
              >
                <React.Fragment>
                  <div
                    style={{ margin: "15px 0px 15px 10px", minWidth: "100px" }}
                  >
                    <Button
                      type="submit"
                      label={isEdit ? "Update" : "Save"}
                      className="mt-2 p-button-raised"
                    />
                  </div>
                </React.Fragment>
              </div>
            </div>
            {isEdit && (
              <Grid className="modsection" container spacing={2}>
                {editMode?.map((item) => (
                  <Grid item xs={3} key={item.name}>
                    <EzControlledInputWithFloatingLabel
                      name={item?.name}
                      control={control}
                      disabled={item?.disabled}
                      label={item?.label}
                      type={item?.type}
                      rules={item?.rule}
                      isError={errors[item?.name]}
                      errorMsg={getFormErrorMessage(item?.name)}
                    />
                  </Grid>
                ))}
              </Grid>
            )}
          </form>
        </div>
      </div>
    </Container>
  );
};

export default CreateCompaniesComponent;
